module.exports = __webpack_public_path__ + "static/logo-a589ed2a44c6c4db2e81d35db577a9f1.svg";